export const DIVISIONS = {
  homecare: {
    key: "homecare",
    name: "ProactiveHomeCare+",
    logo: "/assets/logo-homecare.webp",
    logoBg: "light",
    image: "/assets/hero-slide-3.png",
    eyebrow: "Proactive Home Care",
    heroHeading: "Care That Comes Home",
    tagline: "Compassionate care. Connected everywhere.",
    heroBlurb: "Skilled, coordinated healthcare delivered in the comfort of home — supported by connected monitoring and a team that never stops caring.",
    overview: [
      "ProactiveHomeCare+ delivers clinically-led home health and remote monitoring that keeps patients safe, independent and connected to their care team. From post-acute recovery to long-term chronic care, we wrap technology and human compassion around every individual we serve.",
      "Our connected platform links patients, families and clinicians in real time — so the right care reaches the right person at the right moment.",
    ],
    servicesSub: "Comprehensive home health, coordination and remote monitoring.",
    services: [
      { icon: "Home", title: "Skilled Nursing at Home", text: "Licensed clinicians deliver wound care, medication management and recovery support at home." },
      { icon: "Activity", title: "Remote Patient Monitoring", text: "Connected devices track vitals 24/7 with real-time alerts to the care team." },
      { icon: "Workflow", title: "Care Coordination", text: "One connected plan across physicians, specialists, families and payers." },
      { icon: "HeartPulse", title: "Chronic Care Management", text: "Proactive programs for diabetes, heart, respiratory and complex conditions." },
      { icon: "Stethoscope", title: "Transitional Care", text: "Smooth, safe transitions from hospital to home to reduce readmissions." },
      { icon: "Users", title: "Family Caregiver Support", text: "Education, tools and 24/7 guidance for the people who care most." },
    ],
    capabilities: ["24/7 connected vital monitoring", "Personalized, physician-led care plans", "Telehealth visits from home", "Medication reconciliation & adherence", "Real-time alerts and escalation", "Seamless EHR documentation"],
    stats: [{ value: "24/7", label: "Connected Monitoring" }, { value: "1:1", label: "Personalized Care Plans" }, { value: "Nationwide", label: "Coverage & Coordination" }],
  },

  bh: {
    key: "bh",
    name: "ProactiveBH+",
    logo: "/assets/logo-bh.png",
    logoBg: "light",
    image: "/assets/hero-slide-2.png",
    eyebrow: "Pediatric Behavioral Health",
    heroHeading: "Brighter Minds, Brighter Futures",
    tagline: "Brighter minds. Brighter futures.",
    heroBlurb: "Specialized, family-centered behavioral health for children and adolescents — meeting every young person with expertise, empathy and hope.",
    overview: [
      "ProactiveBH+ provides pediatric behavioral and mental health services designed around each child’s needs, strengths and family. Our multidisciplinary teams combine evidence-based therapy with warmth and understanding.",
      "We connect care across clinic, school, home and telehealth — so support follows the child wherever they are.",
    ],
    servicesSub: "Evidence-based, child-first behavioral health services.",
    services: [
      { icon: "Brain", title: "Pediatric Therapy", text: "Individual, group and play-based therapy tailored to each child." },
      { icon: "Activity", title: "ABA & Autism Services", text: "Evidence-based applied behavior analysis and developmental support." },
      { icon: "Users", title: "Family Counseling", text: "Guidance and coaching that strengthens the whole family system." },
      { icon: "GraduationCap", title: "School-Based Support", text: "Collaborative programs that support learning and wellbeing." },
      { icon: "Video", title: "Telebehavioral Health", text: "Convenient, secure virtual visits for kids and caregivers." },
      { icon: "Workflow", title: "Care Navigation", text: "Dedicated navigators coordinate every step of the journey." },
    ],
    capabilities: ["Evidence-based, child-first care", "Multidisciplinary clinical teams", "In-person & virtual options", "School and community partnerships", "Family education and coaching", "Coordinated care across settings"],
    stats: [{ value: "0–18", label: "Ages We Serve" }, { value: "Multi", label: "Disciplinary Teams" }, { value: "In-person + Virtual", label: "Flexible Access" }],
  },

  ums: {
    key: "ums",
    name: "ProactiveUMS+",
    logo: "/assets/logo-ums.png",
    logoBg: "dark",
    image: "/assets/hero-slide-1.png",
    eyebrow: "Corporate Platform",
    heroHeading: "One Ecosystem. One Purpose.",
    tagline: "Uniting care, technology, people and possibilities.",
    heroBlurb: "The corporate platform uniting every division of the PUMS ecosystem under one intelligent, scalable healthcare vision.",
    overview: [
      "Proactive Unified MedTech Systems (PUMS) is the corporate platform that brings behavioral health, home care, clinics, MedTech and core technology together as one connected healthcare corporation.",
      "We unify people, technology and operations to deliver a complete continuum of care — building a healthier, more connected tomorrow for the communities we serve.",
    ],
    servicesSub: "The platform pillars that power the entire ecosystem.",
    services: [
      { icon: "FileText", title: "Unified EHR / EMR", text: "One connected record across every division and setting." },
      { icon: "Share2", title: "Interoperability", text: "FHIR / HL7 connectivity that unites systems and partners." },
      { icon: "Cpu", title: "AI-Assisted Operations", text: "Automation that reduces burden and improves outcomes." },
      { icon: "Workflow", title: "Enterprise Integration", text: "Connecting systems, people and data at scale." },
      { icon: "LineChart", title: "Analytics & Automation", text: "Turning data into healthier decisions." },
      { icon: "ShieldCheck", title: "Security & Compliance", text: "HIPAA-ready, enterprise-grade protection." },
    ],
    capabilities: ["One unified corporate platform", "Six specialized divisions", "Nationwide, scalable delivery", "AI, cloud and data at the core", "Patient-centered by design", "Compassion meets technology"],
    stats: [{ value: "6", label: "Specialized Divisions" }, { value: "1", label: "Unified Platform" }, { value: "Nationwide", label: "Reach & Impact" }],
  },

  clinic: {
    key: "clinic",
    name: "ProactiveClinic+",
    logo: "/assets/logo-clinic-edited.png",
    logoBg: "light",
    image: "/assets/hero-doctor.png",
    eyebrow: "Member of PUMS Ecosystem",
    heroHeading: "Comprehensive Care, Close to Home",
    tagline: "Comprehensive care, close to home.",
    heroBlurb: "Multi-specialty clinical care that brings primary, preventive and specialty services together under one connected roof.",
    overview: [
      "ProactiveClinic+ provides comprehensive, patient-centered clinical care — combining primary care, chronic disease management and specialty services in a modern, connected setting.",
      "As a member of the PUMS ecosystem, our clinics are backed by unified records, AI-assisted operations and coordinated care across every division.",
    ],
    servicesSub: "Multi-specialty clinical services, connected to the ecosystem.",
    services: [
      { icon: "Stethoscope", title: "Primary Care", text: "Everyday health, checkups and personalized primary care." },
      { icon: "HeartPulse", title: "Chronic Disease Management", text: "Coordinated programs for long-term conditions." },
      { icon: "ShieldCheck", title: "Preventive & Wellness", text: "Screenings, immunizations and proactive wellness." },
      { icon: "Bone", title: "Spine & Orthopedic Care", text: "Specialized musculoskeletal and spine services." },
      { icon: "Microscope", title: "Diagnostics & Labs", text: "On-site diagnostics and rapid lab results." },
      { icon: "Video", title: "Telehealth Visits", text: "See your care team from wherever you are." },
    ],
    capabilities: ["Multi-specialty clinical teams", "Same-day & telehealth access", "Unified electronic health record", "On-site diagnostics & labs", "Coordinated referrals across PUMS", "Preventive, whole-person care"],
    stats: [{ value: "Multi-Specialty", label: "Clinical Care" }, { value: "Same-Day", label: "Access Options" }, { value: "Connected", label: "To PUMS Ecosystem" }],
  },

  medtech: {
    key: "medtech",
    name: "ProactiveMEDTECH+",
    logo: "/assets/logo-medtech.png",
    logoBg: "dark",
    image: "/assets/hero-tablet.png",
    eyebrow: "A Part of the PUMS Ecosystem",
    heroHeading: "Innovation That Moves Care Forward",
    tagline: "Innovation that moves care forward.",
    heroBlurb: "Connected medical devices, clinical technology and integration engineering that turn data into safer, smarter, faster care.",
    overview: [
      "ProactiveMEDTECH+ designs, integrates and supports the clinical technology that powers modern healthcare. From connected devices to interoperability engineering, we bridge the gap between innovation and the bedside.",
      "We make devices, data and systems work together — reliably, securely and at scale.",
    ],
    servicesSub: "Devices, integration and clinical technology.",
    services: [
      { icon: "Cpu", title: "Connected Medical Devices", text: "Smart, connected devices that stream clinical data in real time." },
      { icon: "Workflow", title: "Device Integration", text: "Seamless integration of devices into EHR and clinical workflows." },
      { icon: "Wrench", title: "Clinical Engineering", text: "Lifecycle management, calibration and field support." },
      { icon: "Share2", title: "Interoperability (FHIR / HL7)", text: "Standards-based data exchange across every system." },
      { icon: "ScanLine", title: "Diagnostics Technology", text: "Advanced diagnostic and imaging technology solutions." },
      { icon: "ShieldCheck", title: "Security & Compliance", text: "Medical-grade security and regulatory alignment." },
    ],
    capabilities: ["FHIR / HL7 standards-based integration", "Real-time device data streaming", "Enterprise-grade security", "24/7 technical support", "Scalable deployment", "Full device lifecycle management"],
    stats: [{ value: "FHIR/HL7", label: "Interoperability" }, { value: "Real-time", label: "Device Data" }, { value: "Enterprise", label: "Grade Security" }],
  },

  core: {
    key: "core",
    name: "ProactiveCore+",
    logo: "/assets/logo-core.webp",
    logoBg: "light",
    image: "/assets/hero-slide-4.png",
    eyebrow: "Member of PUMS Ecosystem",
    heroHeading: "Intelligence That Powers Care",
    tagline: "Smarter infrastructure for a healthier tomorrow.",
    heroBlurb: "The AI, cloud and data backbone of the PUMS ecosystem — secure, scalable infrastructure that powers every division.",
    overview: [
      "ProactiveCore+ delivers the cloud, data and artificial intelligence infrastructure that unifies the entire Proactive UMS ecosystem. We build the secure, intelligent foundation on which better healthcare is delivered.",
      "From predictive analytics to enterprise cybersecurity, ProactiveCore+ turns technology into a strategic advantage.",
    ],
    servicesSub: "AI, cloud, data and digital transformation.",
    services: [
      { icon: "Cloud", title: "Cloud Infrastructure", text: "Reliable, elastic cloud built for healthcare scale and uptime." },
      { icon: "Cpu", title: "AI & Machine Learning", text: "Predictive models and automation that improve outcomes." },
      { icon: "Database", title: "Data Platform & Analytics", text: "Unified data and analytics for real, actionable insight." },
      { icon: "Lock", title: "Cybersecurity", text: "Zero-trust security protecting patients and data." },
      { icon: "Workflow", title: "Digital Transformation", text: "Modernization strategy and delivery, end to end." },
      { icon: "Server", title: "Managed IT Services", text: "24/7 monitoring, support and operations." },
    ],
    capabilities: ["HIPAA-ready cloud architecture", "AI-driven predictive analytics", "Unified enterprise data platform", "Zero-trust cybersecurity", "24/7 managed operations", "Scalable, resilient infrastructure"],
    stats: [{ value: "99.9%", label: "Uptime Target" }, { value: "AI-Driven", label: "Analytics" }, { value: "Zero-Trust", label: "Security" }],
  },
};
